import { DELETE, GET, POST, PUT } from './api';

const table = 'financing-proposals';

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  return await GET(`/${table}${filters}`, true);
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
};

//Giovani novo metodo para upload das imagens das faturas de energia
export const CreateFatura = async (params) => {
  return await POST(`/energy-invoices`, params, true);
};

//Giovani novo metodo para eleger as propostas vencedoras
export const UpdateProposta = async (params) => {
  return await POST(`/energy-invoices`, params, true);
};

export const ReadCuradoriaSolControle = async () => {
  return await GET(
    `/financing-proposal/curadoria/consultasolprotocolos/controle`,
    true
  );
};

export const ReadCuradoriaSolFinanciamentos = async () => {
  return await GET(
    `/financing-proposal/curadoria/consultasolprotocolos/financiamento`,
    true
  );
};

export const UpdateForceCuradoria = async (id, params) => {
  return await PUT(`/${table}/curadoria/${id}`, params, true);
};
